import { PanelShell, Badge, tokens } from "../index";
import { listDistributionAdapters, distributorApiBlockers } from "@djsem/analysis-contract";

/**
 * Distribution module — lists each distributor integration's real capability (manual pack vs.
 * API) and any blockers on direct API access, per the honest distributor adapter registry (V3
 * Pillar 7), plus a note on the manual submission pack workflow.
 *
 * @returns A panel of distributor integration statuses/blockers, and a manual-submission-pack info panel.
 */
export function DistributionModule() {
  const adapters = listDistributionAdapters();
  return (
    <>
      <PanelShell title="Distributor integrations — what actually works today">
        {adapters.map((a) => {
          const blockers = distributorApiBlockers(a);
          return (
            <div key={a.id} style={{ padding: "10px 2px", borderBottom: `1px solid ${tokens.color.border}` }}>
              <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 4 }}>
                <strong style={{ fontSize: 14 }}>{a.label}</strong>
                <Badge tone={a.mode === "manual_pack" ? "ok" : "neutral"}>{a.mode === "manual_pack" ? "manual pack ready" : a.mode}</Badge>
                {a.flags.disabled_by_default ? <Badge>API disabled by default</Badge> : null}
              </div>
              <div style={{ fontSize: 12, color: tokens.color.textDim }}>{a.statusNote}</div>
              {blockers.length > 0 ? (
                <div style={{ fontSize: 11, color: tokens.color.muted, marginTop: 4 }}>
                  Direct API blocked: {blockers.join(" · ")}
                </div>
              ) : null}
            </div>
          );
        })}
      </PanelShell>
      <PanelShell title="Manual submission pack" style={{ marginTop: 12 }}>
        <p style={{ margin: 0, color: tokens.color.textDim, fontSize: 13 }}>
          Metadata, credits, lyrics, artwork and the DSP checklist export as one pack you upload
          to your distributor yourself. Run the readiness check in Releases first.
        </p>
      </PanelShell>
    </>
  );
}
